import React from 'react';
import {TableHead} from "@mui/material";
import TableRowHead from "../../../../../../../components/WMS/List/TableRowHead";
import {FormattedMessage} from "react-intl";
import TableCellHead from "../../../../../../../components/WMS/List/TableCellHead";

function Header() {
    return (
        <TableHead>
            <TableRowHead isDesktop>
                {[
                    <FormattedMessage id={'wms.orderTracker.header.days'} />,
                    <FormattedMessage id={'wms.orderTracker.header.waitForPicking'} />,
                    <FormattedMessage id={'wms.orderTracker.header.inPicking'} />,
                    <FormattedMessage id={'wms.orderTracker.header.readyToSort'} />,
                    <FormattedMessage id={'wms.orderTracker.header.readyToPack'} />,
                    <FormattedMessage id={'wms.orderTracker.header.packing'} />,
                    <FormattedMessage id={'wms.orderTracker.header.readyToShip'} />,
                ].map((column) => (
                    <TableCellHead align={"center"} style={{borderBottomLeftRadius: 0, borderBottomRightRadius: 0}} key={column} variant={'head'}>
                        {column}
                    </TableCellHead>
                ))}
            </TableRowHead>
        </TableHead>
    );
}

export default Header;